import { DEFAULT_CONFIG } from './default-config';
import type { Town } from '@/types/interfaces/config';

const VISIBLE_TOWNS: Town[] = [
	{
		id: 1,
		name: 'Алматы',
		coordinates: {
			latitude: 43.222015,
			longitude: 76.85125
		},
		translit_name: 'almaty',
		config: DEFAULT_CONFIG,
		parstore_id: 1,
		code: 'ALA'
	},
	{
		id: 2,
		name: 'Астана',
		coordinates: {
			latitude: 51.160522,
			longitude: 71.47036
		},
		translit_name: 'astana',
		config: DEFAULT_CONFIG,
		parstore_id: 2,
		code: 'AST'
	},
	{
		id: 3,
		name: 'Шымкент',
		coordinates: {
			latitude: 42.315514,
			longitude: 69.586916
		},
		translit_name: 'shymkent',
		config: DEFAULT_CONFIG,
		parstore_id: 3,
		code: 'SHY'
	},
	{
		id: 4,
		name: 'Семей',
		coordinates: {
			latitude: 50.404964,
			longitude: 80.24919
		},
		translit_name: 'semey',
		config: DEFAULT_CONFIG,
		parstore_id: 4,
		code: 'SEM'
	},
	{
		id: 5,
		name: 'Караганда',
		coordinates: {
			latitude: 49.804684,
			longitude: 73.109383
		},
		translit_name: 'karaganda',
		config: DEFAULT_CONFIG,
		parstore_id: 5,
		code: 'KAR'
	},
	{
		id: 6,
		name: 'Атырау',
		coordinates: {
			latitude: 47.105045,
			longitude: 51.924622
		},
		translit_name: 'atyrau',
		config: DEFAULT_CONFIG,
		parstore_id: 6,
		code: 'ATY'
	},
	{
		id: 7,
		name: 'Актау',
		coordinates: {
			latitude: 43.641098,
			longitude: 51.198509
		},
		translit_name: 'aktau',
		config: DEFAULT_CONFIG,
		parstore_id: 7,
		code: 'AKT'
	},
	{
		id: 8,
		name: 'Павлодар',
		coordinates: { latitude: 52.285577, longitude: 76.940722 },
		translit_name: 'pavlodar',
		config: DEFAULT_CONFIG,
		parstore_id: 8,
		code: 'PAV'
	},
	{
		id: 9,
		name: 'Темиртау',
		coordinates: {
			latitude: 50.058761,
			longitude: 72.953424
		},
		translit_name: 'temirtau',
		config: DEFAULT_CONFIG,
		parstore_id: 9,
		code: 'TEM'
	},
	{
		id: 10,
		name: 'Актобе',
		coordinates: {
			latitude: 50.300377,
			longitude: 57.154555
		},
		translit_name: 'aktobe',
		config: DEFAULT_CONFIG,
		parstore_id: 10,
		code: 'AKB'
	},
	{
		id: 11,
		name: 'Уральск',
		coordinates: {
			latitude: 51.204025,
			longitude: 51.370537
		},
		translit_name: 'oral',
		config: DEFAULT_CONFIG,
		parstore_id: 11,
		code: 'URA'
	},
	{
		id: 12,
		name: 'Талдыкорган',
		coordinates: {
			latitude: 45.017837,
			longitude: 78.382105
		},
		translit_name: 'taldykorgan',
		config: DEFAULT_CONFIG,
		parstore_id: 12,
		code: 'TAL'
	},
	{
		id: 17,
		name: 'Костанай',
		coordinates: { latitude: 53.214486, longitude: 63.632082 },
		translit_name: 'kostanay',
		config: DEFAULT_CONFIG,
		parstore_id: 17,
		code: 'KOS'
	},
	{
		id: 18,
		name: 'Кокшетау',
		coordinates: { latitude: 53.29, longitude: 69.42 },
		translit_name: 'kokshetau',
		config: DEFAULT_CONFIG,
		parstore_id: 18,
		code: 'KOK'
	},
	{
		id: 20,
		name: 'Усть-Каменогорск',
		coordinates: {
			latitude: 49.948313,
			longitude: 82.627857
		},
		translit_name: 'ust-kamenogorsk',
		config: DEFAULT_CONFIG,
		parstore_id: 20,
		code: 'USK'
	},
	{
		id: 24,
		name: 'Конаев',
		coordinates: {
			latitude: 43.854849,
			longitude: 77.061581
		},
		translit_name: 'qonaev',
		config: DEFAULT_CONFIG,
		parstore_id: 24,
		code: 'KON'
	},
	{
		id: 13,
		name: 'Кызылорда',
		coordinates: { latitude: 44.842563, longitude: 65.502554 },
		translit_name: 'kyzylorda',
		config: DEFAULT_CONFIG,
		parstore_id: 13,
		code: 'KYZ'
	},
	{
		id: 16,
		name: 'Петропавловск',
		coordinates: { latitude: 54.86186, longitude: 69.139617 },
		translit_name: 'petropavl',
		config: DEFAULT_CONFIG,
		parstore_id: 16,
		code: 'PET'
	},
	{
		id: 19,
		name: 'Тараз',
		coordinates: { latitude: 42.899657, longitude: 71.392727 },
		translit_name: 'taraz',
		config: DEFAULT_CONFIG,
		parstore_id: 19,
		code: 'TAR'
	}
];

const ALL_TOWNS: Town[] = [
	...VISIBLE_TOWNS,
	{
		id: 14,
		name: 'Туркестан',
		coordinates: { latitude: 0, longitude: 0 },
		translit_name: 'turkestan',
		config: DEFAULT_CONFIG,
		parstore_id: 14,
		code: 'TUR'
	},
	{
		id: 15,
		name: 'Экибастуз',
		coordinates: { latitude: 51.72969, longitude: 75.326622 },
		translit_name: 'ekibastuz',
		config: DEFAULT_CONFIG,
		parstore_id: 15,
		code: 'EKI'
	},
	{
		id: 21,
		name: 'Рудный',
		coordinates: { latitude: 0, longitude: 0 },
		translit_name: 'rudny',
		config: DEFAULT_CONFIG,
		parstore_id: 21,
		code: 'RUD'
	},
	{
		id: 22,
		name: 'Балхаш',
		coordinates: { latitude: 0, longitude: 0 },
		translit_name: 'balkhash',
		config: DEFAULT_CONFIG,
		parstore_id: 22,
		code: 'BAL'
	},
	{
		id: 23,
		name: 'Жезказган',
		coordinates: { latitude: 0, longitude: 0 },
		translit_name: 'zhezqazghan',
		config: DEFAULT_CONFIG,
		parstore_id: 23,
		code: 'JEZ'
	}
];

export { VISIBLE_TOWNS, ALL_TOWNS };
